const timeline = [
  {
    date: "06-11",
    stage: "起势",
    color: "text-secondary-700 bg-secondary-100",
    title: "直播间一句「想单干」，被全网截成图",
    text: "主播在收尾闲聊时随口感慨了一句想早点单干。十分钟后，这句带笑的话被切成九宫格，配着「要单飞了」的标题传遍全网。起初大家只是吃个瓜，没人想到它会走到今天这一步。",
  },
  {
    date: "06-28",
    stage: "发酵",
    color: "text-primary-700 bg-primary-100",
    title: "机构深夜发文，搬出「契约精神」",
    text: "沉默两周后，签约机构在凌晨发出一份措辞克制的声明，强调三年合约与直播分成条款仍然有效，并对「单飞」传闻表示遗憾。声明的用词被逐字拆解，网友在评论区开启第一轮站队。",
  },
  {
    date: "07-09",
    stage: "对线",
    color: "text-primary-700 bg-primary-100",
    title: "双方隔空喊话，细节越吵越多",
    text: "主播开播回应「没说要走」，却顺势谈起了过去一年分成不透明、商务被压价。机构随即晒出部分打款记录。真真假假的数据混在一起，最核心的合同条款反而没人能说得清。",
  },
  {
    date: "07-30",
    stage: "反转",
    color: "text-accent-700 bg-accent-100",
    title: "一段旧录像流出，舆论瞬间转向",
    text: "有人扒出两年前的一次内部会议录音片段：机构负责人亲口承诺「人红了分成好谈」。这段被视为「口头承诺」的录像，成了整件事最重要的分水岭——争议焦点从分成数字，转向了「承诺到底算不算数」。",
  },
  {
    date: "08-16",
    stage: "博弈",
    color: "text-secondary-700 bg-secondary-100",
    title: "粉丝站队、平台下场，事情越滚越大",
    text: "头部粉丝团公开「表忠心」，部分品牌方暂停合作观望；平台方则以「维护生态」为由介入协调。压力集中在同一时间点涌来，谁都不愿意先松口。",
  },
  {
    date: "08-31",
    stage: "悬念",
    color: "text-accent-700 bg-accent-100",
    title: "官宣「友好分手」，但细则全在暗示里",
    text: "双方最终以「双方友好协商，回归各自发展」收场。可合同买断金、账号归属、未来商务承接，全被含糊带过。官方没说的部分，往往才是真正的重头戏。",
  },
];

export default function Timeline() {
  return (
    <section id="laiqu" className="mx-auto max-w-[1240px] scroll-mt-24 px-4 md:px-6">
      <div className="mx-auto max-w-3xl text-center">
        <p className="flex items-center justify-center gap-2 text-sm font-medium text-primary-600">
          <i className="ri-timeline-view h-4 w-4" />
          来龙去脉 · 按时间线梳理
        </p>
        <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
          完整过程，一条时间线看懂
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-sm leading-7 text-foreground-600 md:text-base">
          82 天，六次转折。下面每一格都标注了日期与阶段，配上当时没人注意到的细节，帮你把碎片拼回一整块。
        </p>
      </div>

      <div className="relative mx-auto mt-12 max-w-3xl">
        <span className="absolute bottom-6 left-[22px] top-2 w-px bg-background-300 md:left-[94px]" />

        <div className="space-y-10 md:space-y-14">
          {timeline.map((item, i) => (
            <div key={item.date} className="relative flex flex-col gap-4 md:flex-row md:gap-8">
              <div className="flex shrink-0 items-center md:w-[86px] md:justify-end md:text-right">
                <span className="font-heading text-xl font-bold text-foreground-800">{item.date}</span>
              </div>

              <div className="relative z-10 flex w-11 shrink-0 items-start justify-center">
                <span
                  className={`flex h-8 w-8 items-center justify-center rounded-full border-4 border-background-50 ${item.color}`}
                >
                  <i className="ri-record-circle-line h-3 w-3" />
                </span>
              </div>

              <div className="flex-1 rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
                <div className="flex flex-wrap items-center gap-2">
                  <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-medium ${item.color}`}>
                    {String(i + 1).padStart(2, "0")} · {item.stage}
                  </span>
                  <span className="text-xs text-foreground-400">第 {i + 1} 幕</span>
                </div>
                <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950 md:text-xl">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm leading-7 text-foreground-600">{item.text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="relative z-10 mt-6 rounded-lg bg-foreground-950 p-5 text-background-100 md:p-6">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <p className="flex items-center gap-2 font-heading text-lg font-bold">
                <i className="ri-hourglass-2-line h-5 w-5 text-secondary-400" />
                故事还没结束
              </p>
              <p className="mt-1 text-sm leading-6 text-background-100/80">
                最新进展仍在持续。锁定本页，我们会在关键节点出现的第一时间更新这条时间线。
              </p>
            </div>
            <button
              type="button"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-600"
            >
              <i className="ri-refresh-line h-4 w-4" />
              稍后回来刷新
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}